// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608100834/js/" + chunkId + "." + {"44":"3fa6bd88","225":"bd829d95","481":"dff37b0b","486":"f46ac95c","770":"700760f3"}[chunkId] + ".0.5836362190906711.chunk.js";
};